import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  showDiscountedRanges: false,
  brandClasses: {
    original: 'c-grey-20',
    sale: 'c-red-30'
  }
} satisfies RecursivePartial<ProductConfig['pricing']>
